import { MatchHeight } from 'js-match-height';

const selectors = {
  sectionTriggers: '[data-section-trigger]',
  subMenuTriggers: '[data-submenu-trigger]'
};

export default function init() {

  const menuBtns = document.querySelectorAll(".account-menu__item"),
        subMenuBtns = document.querySelectorAll(".account-menu__sub-menu__items"),
        overviewCards = document.querySelector(".account-container__main__flex .overview-cards"),
        settingsContainer = document.querySelector(".settings-container"),
        addressContainer = document.querySelector(".address-container"),
        recentOrdersContainer = document.querySelector(".recent-orders-container"),
        orderHistoryContainer = document.querySelector(".order-history-container"),
        accountMenu = document.querySelector(".account-container__main__flex .account-menu"),
        goBackLink = document.querySelector(".account-container__main__header .go-back-link"),
        editBtn = document.querySelector(".edit-btn"),
        createNewAddressBtn = document.querySelector(".create-new-address-btn"),
        reviewOrdersBtn = document.querySelector(".review-orders-btn"),
        accountTitle = document.querySelector(".account-title");

  const nodeSelectors = {
    sectionTriggers: document.querySelectorAll(selectors.sectionTriggers),
    subMenuTriggers: document.querySelectorAll(selectors.subMenuTriggers)
  };

  for (var i = nodeSelectors.sectionTriggers.length - 1; i >= 0; i--) {
    nodeSelectors.sectionTriggers[i].addEventListener('click', (clickEvent) => {
      clickEvent.preventDefault()
      var activeSection = document.querySelector('[data-section][aria-hidden="false"]')
      var thisSectionId = clickEvent.currentTarget.dataset.sectionTrigger
      var newSection = document.querySelector(`[data-section="${thisSectionId}"`)
      activeSection.ariaHidden = true
      newSection.ariaHidden = false
      var overrideName = clickEvent.currentTarget.dataset.titleOveride
      if(!overrideName) {
        overrideName = clickEvent.currentTarget.innerText
      } 
      changeTitle(overrideName);
    })
  }

  for (var i = nodeSelectors.subMenuTriggers.length - 1; i >= 0; i--) {
    nodeSelectors.subMenuTriggers[i].addEventListener('click', (clickEvent) => {
      clickEvent.preventDefault()
      var currentActive = document.querySelector('.active-submenu-parent')
      if(currentActive){
        currentActive.classList.remove('active-submenu-parent')
        var currentActiveSubMenu = currentActive.nextElementSibling
        currentActiveSubMenu.ariaHidden = "true"
      }
      var thisItem = clickEvent.currentTarget
      thisItem.classList.add('active-submenu-parent')
      var theSubMenu = clickEvent.currentTarget.nextElementSibling
      if (theSubMenu.ariaHidden === "true") {
        theSubMenu.ariaHidden = "false";
      } else {
        theSubMenu.ariaHidden = "true";
      }
    })
  }

  function changeTitle(text) {
    accountTitle.innerHTML = text;
  }

    window.addEventListener(
      "load",
      (e) => {
        if (window.innerWidth <= 850) {
          hideAllContainers();
        }
        overviewBtnListeners()
      },
      false
    );

    window.addEventListener(
      "resize",
      (e) => {
        if (e.target.innerWidth <= 850) {
          hideAllContainers()
          accountTitle.innerHTML = menuBtns[0].dataset.menuTitle;
        }
      },
      false
    );
  
  goBackLink.addEventListener('click', () => {
    hideAllContainers()
    unhideElement(accountMenu)
  })
  
  function overviewBtnListeners() {
    editBtn.addEventListener('click', e => {
      hideAndShowTabs(menuBtns[4], menuBtns)
      hideAndShowContainers(5)
      changeTitle(menuBtns[5])
    })
    createNewAddressBtn.addEventListener('click', e => {
      hideAndShowTabs(menuBtns[4], menuBtns);
      hideAndShowContainers(6)
      changeTitle(menuBtns[6])
    })
    reviewOrdersBtn.addEventListener('click', e => {
      hideAndShowTabs(menuBtns[1], menuBtns);
      hideAndShowContainers(2);
      changeTitle(menuBtns[2]);
    })
  }

  // editCustomerCta.addEventListener('click', e => {
  //   e.preventDefault();
  // //   (async function() {
  // //     const url = `https://maharishi-ayurveda-products.myshopify.com/admin/api/2021-01/customers/${editCustomer.dataset.customerIdNumber}.json`;
  // //     let userDetails = {
  // //       'customer.email': 'kimona@pm.me',
  // //       'customer.first_name': 'Jimbo' ,
  // //       'customer.last_name': 'Slice'
  // //     };
      
  // //     const response = await fetch(url, {
  // //       method: "PUT",
  // //       credentials: "omit",
  // //       headers: {
  // //         "Accept": "application/json",
  // //         "Content-Type": "application/json;charset=utf-8",
  // //         "Authorization": "Basic " + btoa(`69fe892dcea0a68937ff4285e20353bf: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`),
  // //       },

  // //       //make sure to serialize your JSON body
  // //       body: JSON.stringify({ userDetails }),
  // //     });

  // //     let result = await response.json();
  // //   })()
  //   alert("Ability to edit customer details is still under construction");
  // })
}